import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
 import aboutUSImg from "../../Assests/aboutUSImg.jpg";

const AboutSection = () => {
  return (
    <section className="py-16 sm:py-20 bg-gray-50 relative overflow-hidden">
      {/* Subtle background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(8,145,178,0.04),transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(37,99,235,0.02),transparent_60%)]"></div>

      {/* Floating geometric elements */}
      <div className="absolute top-10 right-10 w-32 h-32 bg-gradient-to-br from-lumbini-cyan/5 to-transparent rounded-full opacity-30"></div>
      <div className="absolute bottom-10 left-10 w-24 h-24 bg-gradient-to-br from-lumbini-blue/8 to-transparent rounded-full opacity-25"></div>
      <div className="absolute top-1/2 right-1/4 w-16 h-16 bg-gradient-to-br from-accent-400/6 to-transparent rounded-full opacity-20"></div>

      <div className="container-custom px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-gray-900"
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 sm:mb-8 text-gray-900">
              About <span className="text-lumbini-blue">Lumbini</span>
            </h2>

            <div className="text-left space-y-4 sm:space-y-6 text-base sm:text-lg leading-relaxed text-gray-600">
              <p >
                Lumbini Consultancy Services Pvt. Ltd. provides end-to-end technical and strategic support to NGOs, MSMEs, startups, and public sector entities across India and beyond              </p>

              <p>
                It addresses key challenges in social development (health, education, livelihoods), environmental sustainability, energy efficiency, insurance, HR systems, financial compliance, research, and skill development.              </p>

              <p>
                The organization also supports quality assurance and supply-chain management for consumer goods, including export-import facilitation. Lumbini empowers social entrepreneurs by strengthening institutional systems and marketing strategies.               </p>
              <p>
                Its core strength lies in delivering integrated, context-sensitive solutions tailored to diverse sectors—bridging operational gaps and driving sustainable impact through innovation, documentation, and strategic advisory.</p>
            </div>

            <div className="mt-8 sm:mt-12">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-900">Our Values</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
                <div className="text-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-lumbini-blue to-lumbini-cyan rounded-lg flex items-center justify-center mx-auto mb-2 sm:mb-3">
                    <CheckCircle className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-gray-900">Quality</h4>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-lumbini-blue to-lumbini-cyan rounded-lg flex items-center justify-center mx-auto mb-2 sm:mb-3">
                    <CheckCircle className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-gray-900">Promptness</h4>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-lumbini-blue to-lumbini-cyan rounded-lg flex items-center justify-center mx-auto mb-2 sm:mb-3">
                    <CheckCircle className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-gray-900">Customized Services</h4>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative mt-8 lg:mt-0"
          >
            <div className="relative rounded-xl overflow-hidden shadow-lg">
              <img
                className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover"
                src={aboutUSImg}
                alt="About Lumbini Consultancy"
              />
            </div>

            <div className="absolute -bottom-3 -left-3 sm:-bottom-6 sm:-left-6 bg-white rounded-lg p-3 sm:p-6 shadow-lg">
              <div className="text-center">
                <div className="text-xl sm:text-3xl font-bold text-lumbini-blue">8+</div>
                <div className="text-xs sm:text-sm text-gray-600">Years Experience</div>
              </div>
            </div>

            <div className="absolute -top-3 -right-3 sm:-top-6 sm:-right-6 bg-gradient-to-br from-lumbini-blue to-lumbini-cyan rounded-lg p-3 sm:p-6 shadow-lg">
              <div className="text-center text-white">
                <div className="text-xl sm:text-3xl font-bold">100+</div>
                <div className="text-xs sm:text-sm opacity-90">Happy Clients</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;

